// 修改配置项时需重启项目

// i18n-ignore
const title = 'IoT监控平台' // 标题

// 高德地图Key、安全密钥、自定义地图样式ID
const AMapKey = '95b533dc58b44f3cbae93cd9efff0858'
const AMapSecret = '6171dc6a7993ecde4079b2646d36f5bb'
const AMapStyleid = '397b948b44d8be326614546c8353fd27'

const isProd = process.env.NODE_ENV === 'production' // 是否为生产环境
const proxy = isProd ? '/' : '/api' // 代理映射

const manageProxy = isProd ? '/' : '/manageApi' // manage
const etbcAuthProxy = isProd ? '/' : '/etbcAuthProxy'

const proxyList = [
	{
		proxy: etbcAuthProxy,
		target: 'http://iot.test.eslink.net.cn',
	},
	{
		proxy: proxy,
		// target: 'http://iot.test.eslink.net.cn',
		// target: 'http://ale-test.iot-light.cn',
		// target: 'http://iot.test-new.eslink.net.cn',
		// target: 'http://shenran.iot-sr.cn',
		// target: "http://water0820.iot-water.cn", // shwcsadmin/jk300349
		// target: 'https://test0620.iot-test.jinka.cn', //pzztest  jk300349
		// target: 'http://shwcs.iot.cn/',
		// target: 'http://manage.iot.cn',
		target: 'http://test1129.iot.cn',
		// target: 'http://brscs.iot.cn',
		// target: 'http://10.8.36.185:8888',
		// target: 'http://func1117.iot.cn',
		// target: 'https://manage.iot-test.jinka.cn',
		// target: 'http://srzhcf.iot.cn',
		// target: 'http://test0331.iot.cn',
		// target: "http://lkd02.iot-water.cn", // lkd jk300349
		// target: 'http://test1216.iot.cn', //cytest2/000000a
		// target: 'http://manage.iot.cn', //jkadmin/000000a
		// target: 'http://tjtd.iot.cn', //yhq/cs123456..
		// target: 'http://test.iot-light.cn', //xyw/jk300349!@!.
		// target: 'https://manage.iot-test.jinka.cn', //jkadmin  000000.
	},
	{
		proxy: manageProxy,
		target: 'http://manage.iot.cn',
		// target: "http://manage.iot-sr.cn",
		// target: 'http://tjtd.iot.cn', //yhq/cs123456..
	},
]

module.exports = {
	title,
	AMapKey,
	AMapSecret,
	AMapStyleid,
	isProd,
	proxy,
	manageProxy,
	baseURL: isProd ? '/' : proxy, // 接口默认地址
	proxyList: isProd ? [] : proxyList,
	etbcAuthProxy,
}
